import { Box, Button, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ReportHeader from '../../../common/ReportHeader'
import { bookingMenu, othersMenuVSBL } from '../../../../redux/Actions'
import MultiSelectDropDown from '../../../form-components/MultiSelectDropDownComponent'
import CustomDatePicker from '../../../common/CustomDatePicker'
import { focusElemnt, formatDate, navigation1, navigation3 } from '../../../../utilityFunctions'
import RefundPOSTable from './RefundPOSTable'
import { CountersfilterList, getBusStationListAll } from '../../../../redux/KSRTC_Redux/MasterConfig/MasterAction'
import { modificationTypeOptList } from '../othersConstant'
import moment from 'moment'
import { getListofPaymentDoneModPending } from '../../../../redux/KSRTC_Redux/others/OthersAction'
import Alert from '../../../common/Alert'
import SuccessfulModal from '../../../common/successfulModal'
import { SuccessfulMessage } from '../../../common/constants'

const PosRefund = () => {
    const store = useSelector((store) => store);
    const dispatch = useDispatch()
    const { user, masterConfig } = store
    const [filterValue, setFilterValue] = useState({
        fromDate: formatDate(window.getTime ? window.getTime() : new Date()),
        toDate: formatDate(window.getTime ? window.getTime() : new Date()),
        busStation: [],
        counter: [],
        modificationType: modificationTypeOptList
    })
    const [filterOpt, setFilterOpt] = useState({
        busStation: [],
        counter: [],
    })
    const [showTable, setShowTable] = useState(false)
    const [reportData, setReportData] = useState([])
    const [showAlert, setShowAlert] = useState({
        msg: '',
        open: false
    })
    const [successModal, setSuccessModal] = useState({
        msg: '',
        open: false
    })

    useEffect(() => {
        if (user?.CompanyID) {
            fetchData()
        }
        focusElemnt('FromTxnDate')
    }, [user?.CompanyID])
    useEffect(() => {
        let busStationOpt = masterConfig?.busStationList?.map((obj) => ({ ...obj, BranchName: `${obj.BranchName}(${obj?.BranchCode})` }))
        let counterOpt = masterConfig?.countersFilter?.map((obj) => ({ ...obj, CounterName: `${obj.CounterName}(${obj?.CounterCode})` }))

        setFilterOpt((prev) => ({
            ...prev,
            busStation: busStationOpt,
            counter: counterOpt
        }))
        setFilterValue((prev) => ({
            ...prev,
            busStation: busStationOpt,
            counter: counterOpt
        }))
    }, [masterConfig])
    const busStationProps = () => {
        return {
            width: "100%",
            name: "BusStation",
            id: `BusStation`,
            label: "Bus Station",
            isCompulsory: false,
            options: filterOpt?.busStation || [],
            preSelectedValues: filterValue?.busStation || [],
            searchPlaceholder: "Search by Bus Station",
            disabled: false,
            isObject: true,
            primaryKey: "BranchID",
            labelKey: "BranchName",
            singleSelect: true,
            selectAllOption: true,
            defaultAllSelected: true,
            prevId: "ToTxnDate",
            nextId: "counter",
            searchByCode: true,
            searchByName: "BranchCode"
        };
    };
    const handleBusStation = (val) => {
        resetValue()
        if (val?.length === 1) {
            let filterCounter = masterConfig?.countersFilter?.filter((obj) => obj?.BranchID === val?.[0]?.BranchID)?.map((obj) => ({ ...obj, CounterName: `${obj.CounterName}(${obj?.CounterCode})` }))
            setFilterOpt((prev) => ({
                ...prev,
                counter: filterCounter
            }))
            setFilterValue((prev) => ({
                ...prev,
                busStation: val,
                counter: filterCounter
            }))
        } else {
            let filterCounter = masterConfig?.countersFilter?.map((obj) => ({ ...obj, CounterName: `${obj.CounterName}(${obj?.CounterCode})` }))
            setFilterOpt((prev) => ({
                ...prev,
                counter: filterCounter
            }))
            setFilterValue((prev) => ({
                ...prev,
                busStation: val,
                counter: filterCounter
            }))
        }

    }
    const counterProps = () => {
        return {
            width: "100%",
            name: "counter",
            id: "counter",
            label: "Counter",
            isCompulsory: false,
            options: filterOpt?.counter || [],
            preSelectedValues: filterValue?.counter || [],
            searchPlaceholder: "Search by Counter",
            disabled: false,
            isObject: true,
            primaryKey: "CounterID",
            labelKey: "CounterName",
            singleSelect: true,
            selectAllOption: true,
            defaultAllSelected: true,
            prevId: "BusStation",
            nextId: "modificationType",
            searchByCode: true,
            searchByName: "CounterCode"
        };
    };
    const modificationTypeProps = () => {
        return {
            width: "100%",
            name: "modificationType",
            id: "modificationType",
            label: "Modification Type",
            isCompulsory: false,
            options: modificationTypeOptList || [],
            preSelectedValues: filterValue?.modificationType || [],
            searchPlaceholder: "Search by Modification Type",
            disabled: false,
            isObject: true,
            primaryKey: "id",
            labelKey: "name",
            singleSelect: true,
            selectAllOption: true,
            defaultAllSelected: true,
            prevId: "counter",
            nextId: "searchButton",
        };
    };

    const fetchData = async () => {
        const busStationBody = {
            CompanyID: user?.CompanyID,
            BranchID: 0,
            IsOutStation: -1,
            UserID: 0
        }
        const counterBody = {
            CounterID: 0,
            BranchID: 0,
            CounterTypeID: 0,
            CompanyID: user?.CompanyID
        }
        await Promise.all([
            dispatch(getBusStationListAll(busStationBody, true, 60 * 60 * 1000)),
            dispatch(CountersfilterList(counterBody, true, 60 * 60 * 1000)),
        ])
    }

    const handleReset = () => {
        resetValue()
        let busStationOpt = masterConfig?.busStationList?.map((obj) => ({ ...obj, BranchName: `${obj.BranchName}(${obj?.BranchCode})` }))
        let counterOpt = masterConfig?.countersFilter?.map((obj) => ({ ...obj, CounterName: `${obj.CounterName}(${obj?.CounterCode})` }))

        setFilterOpt((prev) => ({
            ...prev,
            busStation: busStationOpt,
            counter: counterOpt
        }))
        setFilterValue((prev) => ({
            ...prev,
            busStation: busStationOpt,
            counter: counterOpt,
            fromDate: formatDate(window.getTime ? window.getTime() : new Date()),
            toDate: formatDate(window.getTime ? window.getTime() : new Date()),
            modificationType: modificationTypeOptList
        }))
    }
    const resetValue = () => {
        setShowTable(false)
        setReportData([])
    }

    const handleSubmit = () => {
        resetValue()
        const body = {
            FromDate: moment(filterValue?.fromDate).format('YYYY-MM-DD'),
            ToDate: moment(filterValue?.toDate).format('YYYY-MM-DD'),
            BranchID: filterValue?.busStation?.length === 1 ? filterValue?.busStation?.[0]?.BranchID : 0,
            ModificationTypeID: filterValue?.modificationType?.length === 1 ? filterValue?.modificationType?.[0]?.id : -1,
            CounterID: filterValue?.counter?.length === 1 ? filterValue?.counter?.[0]?.CounterID : 0,
            UserID: user?.IsAdmin === 1 || (user?.loginData?.RoleName.toLocaleLowerCase()?.includes('admin')) ? 0 : user?.UserID,
            DeviceID: user?.loginData?.POSDeviceID
        }
        if (user?.IsAdmin === 1 || (user?.loginData?.RoleName.toLocaleLowerCase()?.includes('admin'))) {
            delete body.DeviceID
        }
        dispatch(getListofPaymentDoneModPending(body)).then((res) => {
            if (res?.data?.IsSuccess) {
                if (res?.data?.Data !== null) {
                    setShowTable(true)
                    let data = JSON.parse(res?.data?.Data)
                    setReportData(data?.Table?.map((val, index) => ({ ...val, Sno: index + 1, EntryDateTime: moment(val?.EntryDateTime).format('DD-MMM-YYYY'), status: Number(val?.RefundAmount) === 0 ? '' : `Refund Initiated\nUser:${val?.RefundBy}\nOn:${moment(val?.RefundDateTime).format('DD-MMM-YYYY HH:mm')}` })))
                }
            } else {
                setShowAlert({
                    msg: res?.data?.ErrorMessage !== null ? res?.data?.ErrorMessage : 'No Record Found',
                    open: true
                })
            }
        })
    }

    const handleAlertClose = () => {
        setShowAlert((prev) => ({
            ...prev,
            msg: '',
            open: false
        }))
    }
    return (
        <Box sx={{ paddingBottom: '60px' }}>
            <ReportHeader headerName={"POS Failure GPC"} mainHeaderName="Booking" openSubMenu={() => dispatch(bookingMenu(true))} fixedTopPosition={true} />
            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                columnSpacing={{ xs: 1.5 }}
                sx={{
                    padding: "16px",
                }}
            >
                <Grid item md={1.8}>
                    <CustomDatePicker id={`FromTxnDate`} label={"From Txn Date"}
                        selectedDate={filterValue.fromDate}
                        onChange={(value) => {
                            if (new Date(value) < new Date(filterValue.toDate)) {
                                setFilterValue({ ...filterValue, fromDate: formatDate(value) })
                            } else {
                                setFilterValue({ ...filterValue, fromDate: formatDate(value), toDate: formatDate(value) })
                            }
                            resetValue()
                        }}
                        minDate={''}
                        onKeyDown={(e) => { navigation1(e, "ToTxnDate", "resetButton"); }} />
                </Grid>
                <Grid item md={1.8}>
                    <CustomDatePicker id={`ToTxnDate`} label={"To Txn Date"}
                        selectedDate={filterValue?.toDate} onChange={(value) => {
                            setFilterValue({ ...filterValue, toDate: formatDate(value) })
                            resetValue()

                        }}
                        onKeyDown={(e) => { navigation1(e, "BusStation", "FromTxnDate"); }}
                        minDate={filterValue?.fromDate}
                    />

                </Grid>
                <Grid item md={2}>
                    <MultiSelectDropDown
                        {...busStationProps()}
                        onSelect={handleBusStation}
                    />
                </Grid>
                <Grid item md={2}>
                    <MultiSelectDropDown
                        {...counterProps()}
                        onSelect={(val) => {
                            resetValue()
                            setFilterValue((prev) => ({
                                ...prev,
                                counter: val
                            }))
                        }}
                    />
                </Grid>
                <Grid item md={2}>
                    <MultiSelectDropDown
                        {...modificationTypeProps()}
                        onSelect={(val) => {
                            resetValue()
                            setFilterValue((prev) => ({
                                ...prev,
                                modificationType: val
                            }))
                        }}
                    />
                </Grid>
                <Grid item md={1.2} >
                    <Button variant="contained" id={`searchButton`} className="btn-orange" onClick={() => {
                        handleSubmit()
                    }} onKeyDown={(e) => navigation3(e, "resetButton", "modificationType", () => { })} >SEARCH</Button>
                </Grid>
                <Grid item md={1.2} >
                    <Button variant="outline" id={`resetButton`} className="btn-orange-outline" onClick={() => {
                        handleReset()
                    }} onKeyDown={(e) => navigation3(e, "FromTxnDate", "searchButton", () => { })} >RESET</Button>
                </Grid>

            </Grid>
            {showTable &&
                <RefundPOSTable reportData={reportData} setShowAlert={setShowAlert} setSuccessModal={setSuccessModal} handleSubmit={handleSubmit} />
            }
            {showAlert?.open && <Alert msg={showAlert?.msg} alertType={'error'} close={handleAlertClose} buttonText="OK" />}

            <SuccessfulModal open={successModal?.open} width={"300px"} dialogConfirmationMessage={<SuccessfulMessage message={successModal?.msg} />} onClose={() => {
                setSuccessModal({
                    open: false,
                    msg: '',
                })
            }} backgroundColor="#E0EFD8" />

        </Box>
    )
}

export default PosRefund